import { useContext } from 'react';
import { DeleteApiTokenModalContext } from './DeleteApiTokenModalContext';

const useDeleteApiTokenModal = () => {
  const { open } = useContext(DeleteApiTokenModalContext);
  return { open };
};

export default useDeleteApiTokenModal;
